export const tryParseErrorJson = (error) => {
  try {
    return JSON.parse(error)
  } catch (e) {
    return 'Unkown error'
  }
}
